var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#8247E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.023 10.6018C16.5062 10.3333 17.0938 10.3333 17.577 10.6018L24.777 14.6017C25.285 14.8839 25.6 15.4194 25.6 16.0004V18.6018L22.4 20.4004V16.9418L16.8 13.8307L11.2 16.9418V23.059L16.8 26.1701L30.423 18.6018C30.9062 18.3333 31.4938 18.3333 31.977 18.6018L39.177 22.6018C39.685 22.8839 40 23.4194 40 24.0004V32.0004C40 32.5814 39.685 33.1169 39.177 33.399L31.977 37.399C31.4938 37.6675 30.9062 37.6675 30.423 37.399L23.223 33.399C22.715 33.1169 22.4 32.5814 22.4 32.0004V29.399L25.6 27.6004V31.059L31.2 34.1701L36.8 31.059V24.9418L31.2 21.8307L17.577 29.399C17.0938 29.6675 16.5062 29.6675 16.023 29.399L8.82296 25.399C8.31504 25.1169 8 24.5814 8 24.0004V16.0004C8 15.4194 8.31504 14.8839 8.82296 14.6017L16.023 10.6018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonChain);
export default __webpack_public_path__ + "static/media/polygon-chain.99f686b7c588efb7dc9254121d1a3d60.svg";
export { ForwardRef as ReactComponent };